import { addAuthorizationToHeader } from "./authorize";
import { BASE_PATH } from "./base";
const GET_RESOURCE_BY_ID_PATH = BASE_PATH + "/get-resource";
export const getResourceById = async (id) => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    return fetch(GET_RESOURCE_BY_ID_PATH + `/${id}`, {
        method: "GET",
        headers,
    }).then((response) => response.json());
};
export const getTextItems = async (id) => {
    const headers = new Headers();
    addAuthorizationToHeader(headers);
    return fetch(GET_RESOURCE_BY_ID_PATH + `/${id}/text`, {
        method: "GET",
        headers,
    }).then((response) => response.json());
};
